// Modules
import Themes from './Themes';

// Colors
const Colors_light = {
  primary_color: '#6c5dd3',
  secondary_color: '#ffa2c0',
  success_color: '#46bcaa',
  info_color: '#4d69fa',
  warning_color: '#ffcf52',
  danger_color: '#f35421',
  light_color: '#e7eef8',
  dark_color: '#1f2128',
};

const configuration = {
  light_theme: {
    ...Colors_light,
    ...Themes,
  },
  settings: {
    defaultTimezone: 'America/New_York',
  },
  fallback: {
    bgColor: ['#282929'],
  },
};

export default configuration;
